import {Component, computed, inject, signal} from '@angular/core';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {UsersFacade} from '../../users.facade';
import {InlineFieldComponent} from '../../components/inline-field/inline-field';
import {UsersStore} from '../../users.store';
import {Button} from 'primeng/button';
import {FormsModule} from '@angular/forms';
import {DialogFooterContext} from '../../../../shared/components/dialog-footer/dialog-footer.context';
import {User} from '../../../../core/auth/models/user.models';
import {UserRolesPanelComponent} from '../../components/user-roles-panel/user-roles-panel.component';
import {UserProfileStore} from '../../../../core/auth/stores/user-profile.store';
import {UserPasswordPanelComponent} from '../../components/user-password-panel/user-password-panel.component';
import {Divider} from 'primeng/divider';

export type UserFieldType = 'text' | 'select' | 'date';

export interface UserFieldConfig {
	key: keyof User;
	label: string;
	type: UserFieldType;
	editable: boolean;
	options?: { label: string; value: string }[];
}

@Component({
  selector: 'app-user-details',
	imports: [
		InlineFieldComponent,
		Button,
		FormsModule,
		UserRolesPanelComponent,
		UserPasswordPanelComponent,
		Divider,

	],
  templateUrl: './user-details.html',
  styles: ``
})
export class UserDetails {
	private dialogConfig: DynamicDialogConfig = inject(DynamicDialogConfig)
	private facade: UsersFacade = inject(UsersFacade)
	private store: UsersStore = inject(UsersStore)
	private profileStore = inject(UserProfileStore)
	readonly footer = inject(DialogFooterContext)

	onError(msg: string) {
		this.footer.error.set(msg);
	}

	userId = this.dialogConfig.data.userId
	fields: UserFieldConfig[] = [
		{
			key: 'name',
			label: 'Nome',
			type: 'text',
			editable: true
		},
		{
			key: 'surname',
			label: 'Cognome',
			type: 'text',
			editable: true
		},
		{
			key: 'email',
			label: 'Email',
			type: 'text',
			editable: false
		}
	]
	readonly newPassword = signal<string>('')
	readonly repeatedPassword = signal<string>('')

	readonly currentUser = this.profileStore.currentUser

	readonly validPassword = computed(() =>
		this.newPassword().length >= 8 &&
		this.newPassword() === this.repeatedPassword()
	)

	user = computed( () =>
		this.store.users().find((user) => user.id === this.userId)
	)

	updateField<K extends keyof User>(key: K, value: User[K]) {
		if (!this.user()) return;

		this.facade.update(this.userId, { key, value });
	}


	resendRegistration() {
		this.facade.resendUserRegistration(this.userId)
	}

	deleteUser(userId: string) {
		this.facade.softDeleteUser(userId, true)
	}
}
